import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-livre-bon-liv',
  templateUrl: './livre-bon-liv.component.html',
  styleUrls: ['./livre-bon-liv.component.scss']
})
export class LivreBonLivComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
